module.exports = __webpack_public_path__ + "img/wiperx_feature_02.9263ccfd.jpg";